import api from 'utils/api'
import {
  FETCH_VENUE_SETTINGS_REQUESTED,
  FETCH_VENUE_SETTINGS_SUCCEEDED,
  FETCH_VENUE_SETTINGS_FAILED,
  CREATE_VENUE_SETTINGS_REQUESTED,
  CREATE_VENUE_SETTINGS_SUCCEEDED,
  CREATE_VENUE_SETTINGS_FAILED,
} from './constants'

export const fetchVenueSettingsRequested = () => ({
  type: FETCH_VENUE_SETTINGS_REQUESTED,
})

export const fetchVenueSettingsSucceded = (payload) => ({
  type: FETCH_VENUE_SETTINGS_SUCCEEDED,
  payload,
})

export const fetchVenueSettingsFailed = () => ({
  type: FETCH_VENUE_SETTINGS_FAILED,
})

export const createVenueSettingsRequested = () => ({
  type: CREATE_VENUE_SETTINGS_REQUESTED,
})

export const createVenueSettingsSucceded = (payload) => ({
  type: CREATE_VENUE_SETTINGS_SUCCEEDED,
  payload,
})

export const createVenueSettingsFailed = () => ({
  type: CREATE_VENUE_SETTINGS_FAILED,
})

export const fetchVenueSettings = (venueUuid) => (dispatch) => {
  dispatch(fetchVenueSettingsRequested())

  return api
    .fetchSettings()
    .then((response) => {
      dispatch(
        fetchVenueSettingsSucceded(
          response.data.settings.filter(
            (setting) => setting.venueUuid === venueUuid
          )
        )
      )
    })
    .catch(() => dispatch(fetchVenueSettingsFailed()))
}

export const createVenueSettings = (data) => (dispatch) => {
  dispatch(createVenueSettingsRequested())

  return api
    .createSettings(data)
    .then((response) => {
      dispatch(createVenueSettingsSucceded(response.data.settings))
    })
    .catch(() => dispatch(createVenueSettingsFailed()))
}
